import { useInfiniteQuery } from '@tanstack/react-query';
import { AppointmentSyncRecord } from 'src/models';
import { api } from 'src/services';
import { UseInfiniteQueryOverrideOptions } from '../common';

export type GetBulkAppointmentUploadHistoryResponse = {
  current_page: number;
  histories: AppointmentSyncRecord[];
  pages: number;
  per_page: number;
  total: number;
};

export type UseGetBulkAppointmentUploadHistoryParams = {
  page?: number;
  perPage?: number;
};

const defaultPageSize = 10;

export const useGetBulkAppointmentUploadHistory = (
  params?: UseGetBulkAppointmentUploadHistoryParams,
  options: UseInfiniteQueryOverrideOptions = {}
) => {
  return useInfiniteQuery({
    ...options,
    queryKey: ['bulkAppointmentUploadHistory', 'infinite', params],
    queryFn: ({ pageParam }) =>
      api
        .get<GetBulkAppointmentUploadHistoryResponse>(
          '/appointments/sync/history',
          {
            params: {
              page: pageParam.page,
              per_page: pageParam.perPage,
            },
          }
        )
        .then(({ data }) => data),
    getNextPageParam: (lastPage, _, lastPageParam) => {
      return lastPageParam.page < lastPage.pages
        ? {
            perPage: params?.perPage ?? defaultPageSize,
            page: lastPageParam.page + 1,
          }
        : undefined;
    },
    initialPageParam: {
      page: 1,
      perPage: params?.perPage ?? defaultPageSize,
    },
  });
};
